module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Regular.19978934b77b258686736c9bae732040.woff2";